import { queryOptions, useQuery } from '@tanstack/react-query';
import axios from '../axios';
import { TError } from '@onesource/schemas';

type TUseGetWpTokenQueryOptions = {
  enabled?: boolean;
};

type TResponse = {
  token: string;
};

export const getGetWpTokenQueryOptions = (options: TUseGetWpTokenQueryOptions) => {
  return queryOptions<TResponse, TError>({
    queryKey: ['wp-token'],
    queryFn: async () => {
      const res = await axios.get('/auth/wp-token');
      return res.data.token;
    },
    enabled: options.enabled ?? true,
    refetchOnWindowFocus: false,
  });
};

export const useGetWpTokenQuery = (options: TUseGetWpTokenQueryOptions = {}) => {
  return useQuery(getGetWpTokenQueryOptions(options));
};
